import { Component, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Fields } from '../../models/Fields/field-model';
import { CategoryService } from '../../services/category/category.service';
import { ProductService } from '../../services/product/product.service';
import { Category } from '../../models/category/category.model';
import { DragulaService } from 'ng2-dragula';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { AddCategoryFieldModel } from '../../models/category/AddCategoryField.model';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-category-fields',
  templateUrl: './category-fields.component.html',
  styleUrls: ['./category-fields.component.css']
})
/** Category-Fields component*/
export class CategoryFieldsComponent {


  field = new Fields();
  modalRef: BsModalRef;
  newFieldID: number;
  public parentCategoryList: Category[];
  public categoryList: Category[];
  public SubcategoryList: Category[];
  public GenericFields: Fields[];
  public CategoryFields: any[];
  public StringGenericFields: Fields[];
  public StringCategoryFields: Fields[];
  categoryFieldModel = new AddCategoryFieldModel();
  config = {
    animated: true
  };
  public parentid: number;
  public categoryid: number;
  
  constructor(public toastr: ToastsManager, vcr: ViewContainerRef, private dragulaService: DragulaService, private modalService: BsModalService, private readonly categoryService: CategoryService,
    private readonly productService: ProductService, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.toastr.setRootViewContainerRef(vcr);
    this.GetCategoryList();
    try {
      this.dragulaService.destroy("VAMPIRES");
    } catch (e) {
    }
    this.dragulaService.createGroup("VAMPIRES", {

    });
    this.StringGenericFields = [];
    this.StringCategoryFields = [];
    this.dragulaService.dropModel("VAMPIRES").subscribe(args => {
    });
    this.rolePermissionService.GetRolePermissions("categoryfields").subscribe(
      data => {
        if (data != null) {
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          
          if (list.length > 0) {
            
            //fill Generic fields list
            this.GetGenericField();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  GetCategoryList() {
    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.parentCategoryList = data;
        this.GetCategoryListByParent(data[0].categoryID);
        this.categoryList = [];
        this.SubcategoryList = [];
        this.GetGenericField();
      }
    )
  }
  showSuccess() {
    this.toastr.success('You are awesome!', 'Success!');
  }

  showError() {
    this.toastr.error('This is not good!', 'Oops!');
  }

  showWarning() {
    this.toastr.warning('You are being warned.', 'Alert!');
  }

  showInfo() {
    this.toastr.info('Just some information for you.');
  }

  showCustom() {
    this.toastr.custom('<span style="color: red">Message in red.</span>', null, { enableHTML: true });
  }
  GetGenericField() {
    this.categoryService.GetGenericFieldsList().subscribe(
      data => {
        this.GenericFields = data;
        try {

          this.StringGenericFields=[];
          this.StringCategoryFields=[];
        } catch (e) {

        }
        this.StringGenericFields = this.GenericFields;
        //this.GenericFields.forEach((element) => {
        //  var f = new FieldListModel();
        //  f.name = element.fieldName.toString();
        //  this.StringGenericFields.push(f);
        //});
       
      }
    )
  }
  GetCategoryListByParent(parentCategoryId: number) {
    this.categoryService.GetCategoryListByParent(parentCategoryId).subscribe(
      data => {
        this.categoryList = data;
        this.GetSubCategoryListByParent(data[0].categoryID);
        this.SubcategoryList = [];
      }
    )
  }

  
  GetSubCategoryListByParent(parentCategoryId: number) {

    this.categoryService.GetCategoryListByParent(parentCategoryId).subscribe(
      data => {
        this.SubcategoryList = data;
        this.categoryFieldModel.categoryID = null;
      }
    )
  }
  GetSubCategoryFieldsListByCategoryID(CategoryId: number) {
    this.categoryService.GetCateoryFieldsList(CategoryId).subscribe(
      data => {
        this.CategoryFields = data;
        try {

          this.StringGenericFields = [];
          this.StringCategoryFields = [];
        } catch (e) {

        }
        this.categoryFieldModel.categoryID = CategoryId;
        this.StringGenericFields = JSON.parse(JSON.stringify(this.GenericFields));
        // fill generic fields
        this.StringCategoryFields = JSON.parse(JSON.stringify(this.CategoryFields));
        this.StringCategoryFields.forEach((element) => {
          this.StringGenericFields.forEach((item, index) => {
            if (item.fieldName === element.fieldName) {
              this.StringGenericFields.splice(index, 1);
              return true;
            }
          });
        });   
      }
    )
  }


  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);

  }
  confirm(): void {
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }
  GetCategoryfieldList(): void {
    if (this.StringCategoryFields.length == 0) {
      this.toastr.error('Please select Fields.', 'Oops!');
      return;
    }
    this.categoryFieldModel.Fields = this.StringCategoryFields;
    this.categoryFieldModel.Fields.forEach((element) => {
      element.categoryID = this.categoryFieldModel.categoryID;
      element.id = "";
    })
    this.categoryService.AddCategoryFields(this.categoryFieldModel).subscribe(
      data => {
        if (data) {
          this.toastr.success('CategoryFields added Successfully.', 'Success');
        } else {
          this.toastr.error('CategoryFields not added.', 'Oops!');
        }
      }
    )
  }
  GetGenericList(): void {
  }
  AddField() {
    this.categoryService.AddFields(this.field).subscribe(
      data => {
        if (data > 0) {
          this.newFieldID = data;
          var f = new Fields();
          f.fieldName = this.field.fieldName.toString();
          f.fieldID = this.newFieldID;
          f.enableFilter = false;
          this.StringGenericFields.push(f);
          this.field.fieldID = this.newFieldID;
          this.GenericFields.push(f);
          this.toastr.success('Field added Successfully.', 'Success');
          this.field = new Fields();
        }
        else {
          this.toastr.error('Field already exist.', 'Oops!');
          this.newFieldID=0;
          this.field = new Fields();
        }
      });
      this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/category-components/category-fields/category-fields.component.ts